import React, { useMemo, useState } from "react"
import { Text } from "grommet"
import { StaticImage } from "gatsby-plugin-image"
import Lottie from "lottie-react"

import ContactForm from "./form/ContactForm"
import {
  AddressInfoContainer,
  AddressInfoCover,
  AnimationContainer,
  ContactContentWrapper,
  ContactIconCover,
  InfoContent,
  MapWrapper,
  RightActions,
  CopyButton,
  SuccessMessageContainer,
} from "./styles"

import successAnimation from "../../data/message-sent-success.json"
import data from "../../assets/data.json"

const ContactUs = () => {
  const [isMessageSent, setisMessageSent] = useState(false)
  const phone = "+65 6455 9938"
  const address =
    data?.address ||
    "200, Braddell Road, Block B, #01-09, BCA Braddell Campus, Singapore 579700"

  const mapSrc = useMemo(() => {
    return `https://www.google.com/maps?q=${encodeURIComponent(address)}&output=embed`
  }, [address])

  const copyToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text)
    } catch {
      // Fallback for older browsers
      const el = document.createElement("textarea")
      el.value = text
      document.body.appendChild(el)
      el.select()
      document.execCommand("copy")
      document.body.removeChild(el)
    }
  }

  const CopyIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="#0f172a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect x="9" y="9" width="13" height="13" rx="2"></rect>
      <path d="M5 15V5a2 2 0 0 1 2-2h10"></path>
    </svg>
  )

  return (
    <ContactContentWrapper>
      {/* Left: Contact details + Map */}
      <AddressInfoContainer>
        {/* Phone */}
        <AddressInfoCover>
          <ContactIconCover>
            <StaticImage src="../../assets/images/phone-icon.png" alt="Phone" />
          </ContactIconCover>

          <InfoContent>
            <h3>Phone Number</h3>
            <h4>
              <a className="fancy-link" href="tel:+6564559938" aria-label={`Call ${phone}`}>
                {phone}
              </a>
            </h4>
          </InfoContent>

          <RightActions>
            <CopyButton onClick={() => copyToClipboard(phone)} aria-label="Copy phone number">
              <CopyIcon />
            </CopyButton>
          </RightActions>
        </AddressInfoCover>

        {/* Email (kept simple; no request for moving line/copy) */}
        <AddressInfoCover>
          <ContactIconCover>
            <StaticImage src="../../assets/images/email-icon.png" alt="Email" />
          </ContactIconCover>

          <InfoContent>
            <h3>Email Address</h3>
            <h4>
              <a className="fancy-link" href="mailto:training@aia.edu.sg">
                training@aia.edu.sg
              </a>
            </h4>
          </InfoContent>

          <RightActions>
            <CopyButton onClick={() => copyToClipboard("training@aia.edu.sg")} aria-label="Copy email">
              <CopyIcon />
            </CopyButton>
          </RightActions>
        </AddressInfoCover>

        {/* Address + Map */}
        <AddressInfoCover>
          <ContactIconCover>
            <StaticImage src="../../assets/images/location-icon.png" alt="Location" />
          </ContactIconCover>

          <InfoContent>
            <h3>Address</h3>
            <h4>
              <a
                className="fancy-link"
                href={`https://www.google.com/maps?q=${encodeURIComponent(
                  "AcePLP, " + address
                )}`}
                target="_blank"
                rel="noreferrer"
                aria-label="Open AcePLP in Google Maps"
              >
                {address}
              </a>
            </h4>
          </InfoContent>

          <RightActions>
            <CopyButton
              onClick={() => copyToClipboard(address)}
              aria-label="Copy address"
            >
              <CopyIcon />
            </CopyButton>
          </RightActions>

          <MapWrapper>
            <iframe
              title="AcePLP Location"
              src={`https://www.google.com/maps?q=${encodeURIComponent(
                "AcePLP, " + address
              )}&output=embed`}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </MapWrapper>
        </AddressInfoCover>

      </AddressInfoContainer>

      {/* Right: Form / Success */}
      {isMessageSent ? (
        <SuccessMessageContainer role="status" aria-live="polite">
          <AnimationContainer>
            <Lottie animationData={successAnimation} loop={false} />
          </AnimationContainer>
          <Text margin={{ top: "small" }} size="large" weight="bold">
            Message sent successfully
          </Text>
          <Text>We&apos;ll be in touch within one working day.</Text>
        </SuccessMessageContainer>
      ) : (
        <ContactForm setisMessageSent={setisMessageSent} />
      )}
    </ContactContentWrapper>
  )
}

export default ContactUs
